/* tslint:disable */
/* eslint-disable */
export enum WorkProjectCheckRuleTypeEnum {
  ProjectFieldCheck = 'PROJECT_FIELD_CHECK',
  TaskExistsCheck = 'TASK_EXISTS_CHECK',
  TaskNamePatternCheck = 'TASK_NAME_PATTERN_CHECK',
  TaskDeadlineCheck = 'TASK_DEADLINE_CHECK',
  TaskTimelineCheck = 'TASK_TIMELINE_CHECK',
  TaskListInfoCheck = 'TASK_LIST_INFO_CHECK',
  TaskDependencyCheck = 'TASK_DEPENDENCY_CHECK',
  DocumentTypeCheck = 'DOCUMENT_TYPE_CHECK',
  CalculationitemDeliveryCheck = 'CALCULATIONITEM_DELIVERY_CHECK',
  FirstPartialInvoiceCheck = 'FIRST_PARTIAL_INVOICE_CHECK',
  LinkedProjectsCheck = 'LINKED_PROJECTS_CHECK',
  ProjectDurationCheck = 'PROJECT_DURATION_CHECK'
}
